import { Skeleton } from '@/core/ui';

export const HistoryLoading = () => {
  return (
    <div className='h-screen bg-content1 relative'>
      <div className='absolute top-0 left-4'>
        <Skeleton className='h-[294px] w-[52px] bg-danger/30' />
        <Skeleton className='h-[87px] w-[52px] bg-olive/30' />
      </div>
      <div className='flex h-full space-x-28'>
        <div className='pl-48 py-16'>
          <Skeleton className='h-12 w-64 rounded-md bg-chalk/10' />

          <div className='w-full h-full flex space-x-12 mt-20'>
            <Skeleton className='w-[360px] h-[768px] rounded-md bg-chalk/10' />
            <div className='flex flex-col space-y-8 max-w-[366px] mt-20'>
              <Skeleton className='w-[62px] h-[82px] rounded-md bg-chalk/10' />
              <Skeleton className='w-64 h-[110px] rounded-md bg-chalk/10' />
              <div className='flex items-center'>
                <Skeleton className='h-[8.5px] w-[41px] bg-olive' />
                <Skeleton className='h-[8.5px] w-[41px] bg-danger' />
              </div>
              <Skeleton className='w-[350px] h-[250px] rounded-md bg-chalk/10' />
            </div>
          </div>
        </div>
        <div className='flex flex-col justify-between h-full'>
          <Skeleton className='w-[480px] h-[480px] rounded-md bg-chalk/10' />
          <div className='ml-20 flex space-x-7'>
            <Skeleton className='w-[504px] h-[504px] rounded-md bg-chalk/10' />
            <div className='max-w-[160px]'>
              <Skeleton className='w-40 h-[250px] rounded-md bg-chalk/10' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
